import { MdSend } from "react-icons/md";
import { FaCar } from "react-icons/fa";
import { useState, useRef, useEffect } from "react";

export default function ChatInput({ disabled, onSend, useTextarea }) {
  const [message, setMessage] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [message]);

  const handleSend = () => {
    if (message.trim()) {
      onSend(message);
      setMessage("");
    }
  };

  const handleVINCheck = () => {
    const vin = prompt("Enter VIN to decode:");
    if (vin && vin.trim()) {
      onSend(`VIN: ${vin.trim()}`);
    }
  };

  return (
    <form
      className="bg-white border border-gray-300 rounded-2xl p-3 flex flex-col gap-2 items-end mb-4 shadow-md z-10"
      onSubmit={(e) => {
        e.preventDefault();
        handleSend();
      }}
      autoComplete="off"
    >
      {useTextarea ? (
        <textarea
          ref={textareaRef}
          name="message"
          placeholder="Type your car model and issue, or paste a VIN to decode it instantly."
          className="w-full bg-white text-black placeholder-gray-500 border border-gray-300 focus:outline-none rounded-md p-3 resize-none overflow-y-auto max-h-48 leading-relaxed"
          rows={1}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />
      ) : (
        <input
          name="message"
          placeholder="Type your car model and issue, or paste a VIN to decode it instantly."
          className="w-full bg-white text-black placeholder-gray-500 border border-gray-300 focus:outline-none rounded-md p-3"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      )}
      <div className="flex gap-2 w-full justify-end">
        <button
          type="button"
          onClick={handleVINCheck}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-md flex items-center justify-center transition"
        >
          <FaCar size={18} className="mr-2" />
          Check VIN
        </button>
        <button
          type="submit"
          disabled={disabled}
          className="bg-[#FD5003] hover:bg-[#e34700] text-white font-semibold px-4 py-2 rounded-md flex items-center justify-center transition"
          style={{ minWidth: "40px" }}
        >
          <MdSend size={20} />
        </button>
      </div>
    </form>
  );
}
